import {Card} from 'platform/components';
import {Box} from 'platform/foundation';

import {useCallback} from 'react';

import {mergeAll} from 'ramda';

import {DOCUMENT_ACTION_COLUMNS} from '@dms/features/document-context';
import i18n from '@dms/i18n';
import {DmsDataGrid, Section, usePermissions} from '@dms/shared';
import {useWarehouseParams} from '@dms/warehouse/shared-components';

import {TestIdProps, suffixTestId} from 'shared/web';

import type {QueryFilterObject} from 'features/eag-grid';

interface IssueNotesProps extends TestIdProps {}

export function IssueNotes(props: IssueNotesProps) {
  const {fastTrackIssueId} = useWarehouseParams();

  const [canEditFastTrackIssue] = usePermissions({
    permissionKeys: ['fastTrackIssueEdit'],
  });

  const queryModifier = useCallback(
    (filter: QueryFilterObject) => mergeAll([filter, {fastTrackId: fastTrackIssueId}]),
    [fastTrackIssueId]
  );

  return (
    <Section data-testid={suffixTestId('wrapper', props)}>
      <Card title={i18n.t('page.warehouse.labels.issueNote')}>
        <Box height="100%">
          <DmsDataGrid
            gridCode="fast-track-issue-note-list"
            emptyState={{headline: i18n.t('general.labels.noData')}}
            actionCallback={() => {}}
            predefinedColumns={DOCUMENT_ACTION_COLUMNS}
            queryModifier={queryModifier}
            autoHeight
            data-testid={DOCUMENTS_GRID_CODE}
          />
        </Box>
      </Card>
    </Section>
  );
}

const DOCUMENTS_GRID_CODE = 'document-context-list-warehouse-fast-track';
